<div class="hc-header">
  <span>Company name</span>
</div>
<div class="hc-section">
  <div nz-row class="hc-row hc-row--dashed">
    <div nz-col nzSpan="11" class="hc-label">
      Company name
    </div>
    <div nz-col nzSpan="13">
      <span class="hc-value">
        {{headCompany?.name}}
      </span>
    </div>
  </div>

  <div nz-row class="hc-row hc-row--dashed">
    <div nz-col nzSpan="11" class="hc-label">
      Place of incorporation
    </div>
    <div nz-col nzSpan="13">
      <span class="hc-value">
        {{getCountryNameById(headCompany?.incorporationPlace)}}
      </span>
    </div>
  </div>

  <div *ngIf="headCompany?.bin" nz-row class="hc-row hc-row--dashed">
    <div nz-col nzSpan="11" class="hc-label">
      BIN
    </div>
    <div nz-col nzSpan="13">
      <span class="hc-value">
        {{headCompany?.bin}}
      </span>
    </div>
  </div>

  <div *ngIf="headCompany?.registrationNumber" nz-row class="hc-row hc-row--dashed">
    <div nz-col nzSpan="11" class="hc-label">
      Registration Number
    </div>
    <div nz-col nzSpan="13">
      <span class="hc-value">
          {{headCompany?.registrationNumber}}
      </span>
    </div>
  </div>

  <div *ngIf="headCompany?.taxNumber" nz-row class="hc-row hc-row--dashed">
    <div nz-col nzSpan="11" class="hc-label">
      Tax registration number in the country of incorporation
    </div>
    <div nz-col nzSpan="13">
      <span class="hc-value">
          {{headCompany?.taxNumber}}
      </span>
    </div>
  </div>

  <div *ngIf="headCompany?.registrationDate" nz-row class="hc-row hc-row--dashed">
    <div nz-col nzSpan="11" class="hc-label">
      Date of registration
    </div>
    <div nz-col nzSpan="13">
      <span class="hc-value">
          {{headCompany?.registrationDate | date: 'dd.MM.yyyy'}}
      </span>
    </div>
  </div>

  <div *ngIf="headCompany?.startActivityDate" nz-row class="hc-row">
    <div nz-col nzSpan="11" class="hc-label">
      Date of starting the activities in the Republic of Kazakhstan
    </div>
    <div nz-col nzSpan="13">
      <span class="hc-value">
          {{headCompany?.startActivityDate | date: 'dd.MM.yyyy'}}
      </span>
    </div>
  </div>
</div>

<div class="hc-header">
  <span>Address Details</span>
</div>
<div class="hc-section">
  <div nz-row class="hc-row hc-row--dashed">
    <div nz-col nzSpan="11" class="hc-label">
      City
    </div>
    <div nz-col nzSpan="13">
      <span class="hc-value">
        {{headCompany?.address?.street}}
      </span>
    </div>
  </div>

  <div nz-row class="hc-row hc-row--dashed">
    <div nz-col nzSpan="11" class="hc-label">
      Postal code
    </div>
    <div nz-col nzSpan="13">
      <span class="hc-value">
        {{headCompany?.address?.postalCode}}
      </span>
    </div>
  </div>

  <div nz-row class="hc-row hc-row--dashed">
    <div nz-col nzSpan="11" class="hc-label">
      Street
    </div>
    <div nz-col nzSpan="13">
      <span class="hc-value">
        {{headCompany?.address?.street}}
      </span>
    </div>
  </div>

  <div nz-row class="hc-row hc-row--dashed">
    <div nz-col nzSpan="11" class="hc-label">
      Building number
    </div>
    <div nz-col nzSpan="13">
      <span class="hc-value">
        {{headCompany?.address?.buildingNumber}}
      </span>
    </div>
  </div>

  <div nz-row class="hc-row">
    <div nz-col nzSpan="11" class="hc-label">
      Office/Room number
    </div>
    <div nz-col nzSpan="13">
      <span class="hc-value">
        {{headCompany?.address?.officeRoomNumber}}
      </span>
    </div>
  </div>
</div>


<div class="hc-header">
  <span>Company Details</span>
</div>
<div class="hc-section">
  <div nz-row class="hc-row hc-row--dashed">
    <div nz-col nzSpan="11" class="hc-label">
      CEO First Name
    </div>
    <div nz-col nzSpan="13">
      <span class="hc-value">
        {{headCompany?.ceoFirstName}}
      </span>
    </div>
  </div>
  <div nz-row class="hc-row hc-row--dashed">
    <div nz-col nzSpan="11" class="hc-label">
      CEO Patronymic Name
    </div>
    <div nz-col nzSpan="13">
      <span class="hc-value">
        {{headCompany?.ceoMiddleName}}
      </span>
    </div>
  </div>
  <div nz-row class="hc-row hc-row--dashed">
    <div nz-col nzSpan="11" class="hc-label">
      CEO Last Name
    </div>
    <div nz-col nzSpan="13">
      <span class="hc-value">
        {{headCompany?.ceoLastName}}
      </span>
    </div>
  </div>

  <div nz-row class="hc-row hc-row--dashed">
    <div nz-col nzSpan="11" class="hc-label">
      Please give a brief description of the head company’s business activities
    </div>
    <div nz-col nzSpan="13">
      <span class="hc-value">
        {{headCompany?.businessActivityDescription}}
      </span>
    </div>
  </div>

  <div nz-row class="hc-row hc-row--dashed">
    <div nz-col nzSpan="11" class="hc-label">
      Is a legal entity is an international organization?
    </div>
    <div nz-col nzSpan="13">
      <span class="hc-value">
        {{headCompany?.isInternational ? 'Yes' : 'No'}}
      </span>
    </div>
  </div>

  <div nz-row class="hc-row hc-row--dashed">
    <div nz-col nzSpan="11" class="hc-label">
      Is the Head Company a subject to the supervision of a Financial Services Regulator in the relevant jurisdiction or
      any other jurisdiction?
    </div>
    <div nz-col nzSpan="13">
      <span class="hc-value">
        {{headCompany?.isSubjectOfSupervision ? 'Yes' : 'No'}}
      </span>
    </div>
  </div>

  <div nz-row class="hc-row hc-row--dashed">
    <div nz-col nzSpan="11" class="hc-label">
      Name of registration authority
    </div>
    <div nz-col nzSpan="13">
      <span class="hc-value">
        {{headCompany?.registrationAuthorityName}}
      </span>
    </div>
  </div>

  <div nz-row class="hc-row hc-row--dashed">
    <div nz-col nzSpan="11" class="hc-label">
      Regime of registration
    </div>
    <div nz-col nzSpan="13">
      <span class="hc-value">
        {{headCompany?.registrationRegime}}
      </span>
    </div>
  </div>

  <div nz-row class="hc-row hc-row--dashed">
    <div nz-col nzSpan="11" class="hc-label">
      Organization legal form
    </div>
    <div nz-col nzSpan="13">
      <span class="hc-value">
        {{headCompany?.orgLegalForm}}
      </span>
    </div>
  </div>

  <div nz-row class="hc-row hc-row--dashed">
    <div nz-col nzSpan="11" class="hc-label">
      Address of registration authority
    </div>
    <div nz-col nzSpan="13">
      <span class="hc-value">
        {{headCompany?.registrationAuthorityAddress}}
      </span>
    </div>
  </div>

  <div nz-row class="hc-row hc-row--dashed">
    <div nz-col nzSpan="11" class="hc-label">
      The date of filing annual return in home jurisdiction
    </div>
    <div nz-col nzSpan="13">
      <span class="hc-value">
        {{annualReturnFilingText}}
      </span>
    </div>
  </div>

  <div nz-row class="hc-row hc-row--dashed">
    <div nz-col nzSpan="11" class="hc-label">
      Is the Head Company obliged to prepare annual accounts in the home jurisdiction?
    </div>
    <div nz-col nzSpan="13">
      <span class="hc-value">
        {{headCompany?.isObligedToPrepareAnnualAccount ? 'Yes' : 'No'}}
      </span>
    </div>
  </div>

  <div *ngIf="headCompany?.isObligedToPrepareAnnualAccount" nz-row class="hc-row">
    <div nz-col nzSpan="11" class="hc-label">
      Please specify the financial year end of the Head Company
    </div>
    <div nz-col nzSpan="13">
      <span class="hc-value">
        {{financialYearEndText}}
      </span>
    </div>
  </div>
</div>

<div class="hc-header">
  <span>Share Capital Details</span>
</div>
<div class="hc-section">
  <div nz-row class="hc-row hc-row--dashed">
    <div nz-col nzSpan="11" class="hc-label">
      Type of share capital
    </div>
    <div nz-col nzSpan="13">
      <span class="hc-value">
        {{headCompany?.shareCapitalType}}
      </span>
    </div>
  </div>

  <div nz-row class="hc-row hc-row--dashed">
    <div nz-col nzSpan="11" class="hc-label">
      Share capital currency
    </div>
    <div nz-col nzSpan="13">
      <span class="hc-value">
        {{headCompany?.shareCapitalCurrency}}
      </span>
    </div>
  </div>

  <div nz-row class="hc-row">
    <div nz-col nzSpan="11" class="hc-label">
      Amount of share capital
    </div>
    <div nz-col nzSpan="13">
      <span class="hc-value">
        {{headCompany?.shareCapitalAmount}}
      </span>
    </div>
  </div>
</div>
